import { UUID } from "node:crypto";
import { RouteFilter } from "@/app/api/types/route";

export const routeKeys = {
  all: ["routes"] as const,
  lists: () => [...routeKeys.all, "list"] as const,
  list: (filters?: RouteFilter) => [...routeKeys.lists(), { filters }] as const,
  details: () => [...routeKeys.all, "detail"] as const,
  detail: (id: UUID) => [...routeKeys.details(), id] as const,
};
